import { Env, Freyr } from "types/Env";

export const getEnv = (): Env => {
  return window as Env;
};

export const getEndpoint = (): Freyr | undefined => {
  return getEnv().freyr;
};
